import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import hoferLogo from 'sigi-assets/assets/img/brand/logo-hofer.svg';

const ppms = (window as any).ppms;

const Footer: React.FC = observer(() => {
	const { t } = useTranslation();

	return (
		<div className="footer-wrapper">
			<footer className="app-footer">
				<div className="contact-list">
					<div className="wrapper">
						<div className="contact web">
							<a className="title" href="/Kontakt">
								{t('footer.contact.callback.label')}
							</a>
						</div>
					</div>
					<div className="wrapper">
						<div className="contact email">
							<a className="title" href="mailto:service@hofer-grünstrom.at">
								service@hofer-grünstrom.at
							</a>
						</div>
					</div>
					<div className="wrapper">
						<div className="contact info">
							<a className="title" href="/faq">
								{t('footer.contact.faq.label')}
							</a>
						</div>
					</div>
				</div>
				<div className="sitemap">
					<div className="sitemap-table">
						<div className="sitemap-col brand-banner">
							<a className="logo-hofer" href="/">
								<img src={hoferLogo} alt={t('navigation.logo.alt')} />
							</a>
							<strong className="small">{t('footer.logo.subtext')}</strong>
						</div>
						<div className="sitemap-col">
							<h5>{t('footer.sitemap.hofer-links.header')}</h5>
							<ul>
								<li>
									<a href="https://www.hofer.at" target="_blank" rel="noopener noreferrer">
										HOFER
									</a>
								</li>
								<li>
									<a
										href="https://www.hofer.at/de/filialen.html?utm_campaign=6731ca55000962c703290eb27cca4862&utm_source=hofergruenstroms.at&utm_medium=footer&utm_content=filialen&utm_term=22092025"
										target="_blank"
										rel="noopener noreferrer">
										HOFER Filialen
									</a>
								</li>
								<li>
									<a href="https://www.hofer-reisen.at" target="_blank" rel="noopener noreferrer">
										HOFER REISEN
									</a>
								</li>
								<li>
									<a
										href="https://www.hot.at/?utm_source=hofer-gr%C3%BCnstrom.at&utm_medium=referral&utm_campaign=alwayson&utm_content=footer"
										target="_blank"
										rel="noopener noreferrer">
										HoT
									</a>
								</li>
								<li>
									<a
										href="https://www.hoferfotos.at/?utm_source=hofergruenstrom&utm_medium=referral&utm_campaign=footerhofergruenstrom"
										target="_blank"
										rel="noopener noreferrer">
										HOFER FOTOS
									</a>
								</li>
								<li>
									<a href="https://www.hofer.at/de/onlineshop.html" target="_blank" rel="noopener noreferrer">
										HOFER ONLINE SHOP
									</a>
								</li>
								<li>
									<a href="https://www.hofer.at/de/sortiment/gutscheinwelt" target="_blank" rel="noopener noreferrer">
										HOFER GUTSCHEINWELT
									</a>
								</li>
								<li>
									<a href="https://www.hofer.at/de/services/hofer-newsletter" target="_blank" rel="noopener noreferrer">
										HOFER NEWSLETTER
									</a>
								</li>
							</ul>
						</div>
						<div className="sitemap-col">
							<h5>{t('footer.sitemap.sitemap.header')}</h5>
							<ul>
								<li>
									<a href="/so-gehts">So geht&apos;s</a>
								</li>
								<li>
									<a href="/umzugsservice">Umzug & Anbieterwechsel</a>
								</li>
								<li>
									<a href="/rechnung">Rechnungserläuterung</a>
								</li>
								<li>
									<a href="/strompreis">Das steckt im Strompreis</a>
								</li>
								<li>
									<a href="/energiesparen">Energiespartipps</a>
								</li>
								<li>
									<a href="/faq">Fragen und Antworten</a>
								</li>
								<li>
									<a href="/ueber-uns">Über uns</a>
								</li>
								<li>
									<a href="/kontakt">{t('footer.contact.callback.label')}</a>
								</li>
							</ul>
						</div>
						<div className="sitemap-col">
							<h5>{t('footer.sitemap.legal.header')}</h5>
							<ul>
								<li>
									<a href="https://www.hofer-grünstrom.at/rechtliches" target="_blank" rel="noopener noreferrer">
										Überblick Rechtliches
									</a>
								</li>
								<li>
									<a href="https://www.hofer-grünstrom.at/alb.pdf" target="_blank" rel="noopener noreferrer">
										ALB
									</a>
								</li>
								<li>
									<a href="/widerruf">Vertrag widerrufen</a>
								</li>
								<li>
									<a href="/impressum">Impressum</a>
								</li>
								<li>
									<a href="/datenschutz">Datenschutz</a>
								</li>
								<li>
									<a href="/downloads">Downloads</a>
								</li>
								{ppms && (
									<li>
										<button
											className="button default link"
											type="button"
											onClick={() => {
												ppms.cm.api('openConsentForm');
											}}>
											Cookie-Einstellungen
										</button>
									</li>
								)}
								<li>
									<a
										href="https://www.hofer-grünstrom.at/barrierefreiheitserklaerung"
										target="_blank"
										rel="noopener noreferrer">
										Barrierefreiheitserklärung
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</footer>
		</div>
	);
});

export default Footer;
